import Store from "../../../../Store/Store";

class PaymentClassContainer {
  public pickIdFromLabel(label) {
    const paymentClass = Store.getConfigurator().getState().globalTypes?.PaymentClass;
    for(const key in paymentClass) {
      if (paymentClass[key].label?.toLowerCase() === label?.toLowerCase()) {
        return paymentClass[key].id
      }
    }
  }
}

export default new PaymentClassContainer();
